import React from 'react';
import HomeOpenHours from '../components/HomeOpenHours';
import ScrollIntoView from '../components/ScrollIntoView';

const Home = () => {
  return (
    <ScrollIntoView>

      <div id="home-page">

        <section id="home-actual">
          <h1>Aktuális</h1>

          <article>
            <h2>Hulladékszállítás</h2>
            
            <p>Tájékoztatjuk Önöket, hogy hulladékszállítási közszolgáltatási tevékenységet a Kisújszállási Városgazdálkodási Nonprofit Kft. már nem végez.</p>
            <p>Hulladékszállítási ügyek intézésével kapcsolatban az <b>NHSZ Tisza Nonprofit Kft</b> alábbi elérhetőségein tájékozódhatnak:</p>
            <p><b>NHSZ TISZA honlapja:</b> <a href="https://www.nhsztisza.hu" target="_blank" rel="noopener noreferrer">https://www.nhsztisza.hu</a></p>
            <p><b>Kisújszállási kihelyezett Ügyfélszolgálat:</b> NHSZ Tisza Nonprofit Kft. 5310 Kisújszállás, Kossuth L. u. 74. <b>HULLADÉKUDVAR</b></p>
            <p><b>Ügyfélszolgálati telefonszám:</b> <a href="tel:59/510011">59/510011</a></p>
            <p><b>Ügyfélszolgálati E-mail cím:</b> <a href="mailto:ugyfelszolgalat.tisza@nhsz.hu">ugyfelszolgalat.tisza@nhsz.hu </a></p>
          </article>

          <article>
            <h2>Virágbolt</h2>
            <p><a target="_blank" href="https://www.facebook.com/Borosty%C3%A1n-Vir%C3%A1gbolt-101413431450608/">Tekintse meg aktuális kínálatunkat a Facebook oldalunkon!</a></p>
          </article>

        </section>

        <section id="home-office">
        </section>

        <HomeOpenHours />

      </div>
    </ScrollIntoView>
  );
};

export default Home;